import * as swcHelpers from '@swc/helpers';
import React__default, { useContext } from 'react';

var BreakpointName;
(function(BreakpointName) {
    BreakpointName["PHONE"] = "PHONE";
    BreakpointName["TABLET_PORTRAIT"] = "TABLET_PORTRAIT";
    BreakpointName["TABLET_LANDSCAPE"] = "TABLET_LANDSCAPE";
    BreakpointName["DESKTOP"] = "DESKTOP";
})(BreakpointName || (BreakpointName = {}));
const MediaQueryContext = /*#__PURE__*/ React__default.createContext({});
const useBreakpoint = ()=>{
    const { currentBreakpoint  } = useContext(MediaQueryContext);
    return currentBreakpoint;
};
const useIsBreakpoint = (name)=>{
    const { currentBreakpoint  } = useContext(MediaQueryContext);
    return currentBreakpoint === name;
};
const useIsPhone = ()=>useIsBreakpoint(BreakpointName.PHONE)
;
const useIsTabletPortrait = ()=>useIsBreakpoint(BreakpointName.TABLET_PORTRAIT)
;
const useIsTabletLandscape = ()=>useIsBreakpoint(BreakpointName.TABLET_LANDSCAPE)
;
const useIsDesktop = ()=>useIsBreakpoint(BreakpointName.DESKTOP)
;
const breakpointRange = [
    BreakpointName.PHONE,
    BreakpointName.TABLET_PORTRAIT,
    BreakpointName.TABLET_LANDSCAPE,
    BreakpointName.DESKTOP, 
];
// Check if the current breakpoint is above the argument
const useIsAbove = (name)=>{
    const { currentBreakpoint  } = useContext(MediaQueryContext);
    return breakpointRange.indexOf(currentBreakpoint) > breakpointRange.indexOf(name);
};
// Check if the current breakpoint is below the argument
const useIsBelow = (name)=>{
    const { currentBreakpoint  } = useContext(MediaQueryContext);
    return breakpointRange.indexOf(currentBreakpoint) < breakpointRange.indexOf(name);
};
function WithBreakpoints(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const withBreakpoints = (props)=>{
        const currentBreakpoint = useBreakpoint();
        return /*#__PURE__*/ React__default.createElement(Component, swcHelpers.extends({}, props, {
            currentBreakpoint: currentBreakpoint
        }));
    };
    withBreakpoints.displayName = `WithBreakpoints(${wrappedName})`;
    return withBreakpoints;
}
var MediaQueryContext$1 = MediaQueryContext;

export { BreakpointName, WithBreakpoints, MediaQueryContext$1 as default, useBreakpoint, useIsAbove, useIsBelow, useIsDesktop, useIsPhone, useIsTabletLandscape, useIsTabletPortrait };
//# sourceMappingURL=MediaQueryContext.js.map
